import { DASHBOARD_SET_SHOW_DASH_CARD, DASHBOARD_SET_DEFAULT_DASH_CARD } from './constants'

export function setShowDashCard(sectionName, selected) {
    return (dispatch) => {
      dispatch({
        type: DASHBOARD_SET_SHOW_DASH_CARD,
        data: {sectionName, selected}
      })
  };
}

export function setDefaultDashCard(sectionName) {
  return (dispatch) => {
    dispatch({
      type: DASHBOARD_SET_DEFAULT_DASH_CARD,
      data: {sectionName}
    })
  };
}

export function reducer(state, action) {
  if (action.type === DASHBOARD_SET_SHOW_DASH_CARD) {
      // primero guardo estado inicial de todas las secciones, si no existe
      if (!state?.defaultCardSelected || (state?.defaultCardSelected && !state?.defaultCardSelected[state.filters.b_type])) {
        const defaultCardSelected = state.dashSections.reduce( (total, section) => {
          return {
            ...total,
           [section.section_name]: section.Dash_cards_by_sections.filter(f=>f.Dash_card.enabled).map(f=>f.id)
         }
        }, {})
        state.defaultCardSelected = {...state.defaultCardSelected, [state.filters.b_type]: defaultCardSelected}
      }
    
      // recupero índice de la sección a donde se va a actualizar datos
      const dashSectionIndex = state.dashSections.findIndex(f=>f.section_name === action.data.sectionName)
      // aplico los cambios de enabled según la selección
      const newDashCardBySection = state.dashSections[dashSectionIndex].Dash_cards_by_sections.map(card => {
        if (action.data.selected.includes(card.id))
            card.Dash_card.enabled = true
        else
            card.Dash_card.enabled = false
        return card
      })
      // aplico los cambios en el state para aplicarlos al store
      state.dashSections[dashSectionIndex].Dash_cards_by_sections = newDashCardBySection

    return {  
      ...state,
      cardSelected: {...state.cardSelected, [state.filters.b_type]: {[action.data.sectionName]: action.data.selected}}
    }
  }

  if (action.type === DASHBOARD_SET_DEFAULT_DASH_CARD) {
    // recupero valor inicial de las seccion
    const defaultCardSelected = state.defaultCardSelected[state.filters.b_type][action.data.sectionName]
    // recupero índice de la sección a donde se va a actualizar datos
    const dashSectionIndex = state.dashSections.findIndex(f=>f.section_name === action.data.sectionName)
    // aplicar valores de Enabled por defecto a la seccion actual
    const newDashCardBySection = state.dashSections[dashSectionIndex].Dash_cards_by_sections.map(card => {
      if (defaultCardSelected.includes(card.id))
          card.Dash_card.enabled = true
      else
          card.Dash_card.enabled = false
      return card
    })
    // aplico los cambios en el state para aplicarlos al store
    state.dashSections[dashSectionIndex].Dash_cards_by_sections = newDashCardBySection
    state.cardSelected[state.filters.b_type][action.data.sectionName] = undefined
    return {
      ...state,
    }
  }
  
  return state
}